import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import AIMeAssistant from './AIMeAssistant';
import './AIMeAssistant.css';

/**
 * AIMeDrawerControl - Controls the AIMeAssistant drawer and its expand/collapse functionality
 * This component manages the drawer state and renders both the drawer and its expand tab
 */
const AIMeDrawerControl = ({ tenantId }) => {
	const [isOpen, setIsOpen] = useState(false);
	const theme = useTheme();

	const handleToggle = () => {
		setIsOpen(!isOpen);
	};

	return (
		<>
			{/* The main AIMeAssistant drawer */}
			<AIMeAssistant open={isOpen} setOpen={setIsOpen} tenantId={tenantId} />

			{/* The expand tab - only visible when drawer is closed */}
			{!isOpen && (
				<Box
					onClick={handleToggle}
					sx={{
						position: 'fixed',
						top: '120px',
						right: 0,
						width: '30px',
						height: '60px',
						bgcolor:
							theme.palette.mode === 'dark'
								? theme.palette.background.paper
								: theme.palette.primary.main,
						color: '#fff',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						cursor: 'pointer',
						zIndex: 2000,
						borderTopLeftRadius: '8px',
						borderBottomLeftRadius: '8px',
						boxShadow: theme.shadows[3],
					}}
				>
					<KeyboardDoubleArrowLeftIcon />
				</Box>
			)}
		</>
	);
};

export default AIMeDrawerControl;
